import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getRoleAllowed,
         initLoggedIn,
         getAllowedCompanies,
         addActivePage,
         getApplicationEnvironment,
         loadTranslation,
         addFlow,
         storeKENNumber,
        // setSurveyStarted,
         getCsrfToken } from '../application_actions';

import { flows } from '../flows';

import { LoadingCircular } from './presentational/loading.jsx';
import { NoteBox } from './presentational/note_box.jsx';


export default function makeBasePage(key) {
  return (Component) => {
    class BasePageComponent extends React.Component {

      constructor(props) {
        super(props);
      }

      componentDidMount() {
        // Not in use for now. See private_route.js
        /* if (this.props.auth.isLoggedIn == undefined){
          this.props.initLoggedIn();
        } */

        if (this.props.auth.csrfToken == undefined) {
          this.props.getCsrfToken();
        }

        if (this.props.auth.roleAllowed == undefined) {
          this.props.getRoleAllowed();
        }

        if (this.props.auth.allowedCompanies == undefined) {
          this.props.getAllowedCompanies();
        }

        this.props.loadTranslation(new URLSearchParams(this.props.location.search).get('lang'), this.props.strings.Common);
        this.props.addActivePage(key);
      }

      selectFlow(flowName, index) {
        var newFlow = flows[flowName];
        if (!newFlow) {
          console.error("flow " + flowName + " not found");
          return;
        }
        this.props.progress.currentIndex = index || index === 0 ? index : this.props.progress.currentIndex
        this.props.addFlow(newFlow);
        this.props.history.push(newFlow[0].path);
      }

      goForward() {
        var current = this.props.progress.currentIndex;
        var next =    this.props.progress.currentIndex + 1;
        var length =  this.props.progress.flow.length;
        if(next === length) {
          storeKENNumber(null);
          this.props.history.push('/main');
        } else {
          this.props.history.push(this.props.progress.flow[next].path);
        }
      }

      goBack() {
        var current = this.props.progress.currentIndex;
        var prev =    this.props.progress.currentIndex - 1;
        
        if (current == 0) {
          this.props.history.push('/main');
        } else {
          this.props.history.push(this.props.progress.flow[prev].path);
        }
      }

      render() {

        if (this.props.auth.roleAllowed == false) {
          var text = "Role not allowed";
          if (this.props.strings && this.props.strings.Common &&
            this.props.strings.Common.roleNotAllowed) {
              text = this.props.strings.Common.roleNotAllowed;
          }

          return (<NoteBox data={[{ "text": text }]} theme="warning" />);
        }

        if(this.props.auth.allowedCompanies == undefined ||
           this.props.auth.roleAllowed == undefined ||
           !this.props.strings.Common) {
          return(
            <LoadingCircular />
          );
        }

        return (

          <Component
            {...this.props}
            goBack={ () => this.goBack() }
            goForward={ () => this.goForward() }
            selectFlow={ (flow, index) => this.selectFlow(flow, index) }
          />
        );
      }
    }

    function mapDispatchToProps(dispatch){
      return bindActionCreators({ getRoleAllowed, getAllowedCompanies, initLoggedIn,
        addActivePage, getApplicationEnvironment, loadTranslation, addFlow, getCsrfToken }, dispatch);
    }

    function mapStateToProps( { auth, progress, i18n, app, env } ) {

      var pageParams = Object.assign({}, progress.flow[progress.currentIndex]);
      return { app, auth, progress, strings: i18n.strings, env, pageParams, i18n, };
    }

    return connect(mapStateToProps, mapDispatchToProps)(BasePageComponent);
  }
}
